(function () {
	const configEl = document.getElementById('contact-form-webhook-config');
	if (!configEl || !configEl.dataset.webhookUrl) return;

	const form = document.getElementById('ContactForm');
	if (!form) return;

	let isSubmittingAfterWebhook = false;

	const parseContactFieldName = function (name) {
		const match = name && name.match(/^contact\[(.+)\]$/);
		return match ? match[1] : name;
	};

	const getLogicalFieldName = function (name) {
		return parseContactFieldName(name).replace(/_\d+$/, '');
	};

	const getFieldLabel = function (el) {
		if (el.id) {
			const label = document.querySelector('label[for="' + CSS.escape(el.id) + '"]');
			if (label) {
				return label.textContent.replace(/\*/g, '').trim();
			}
		}
		const parentLabel = el.closest('label');
		if (parentLabel) {
			const span = parentLabel.querySelector('span');
			if (span) {
				return span.textContent.trim();
			}
		}
		return parseContactFieldName(el.name);
	};

	const buildFieldsFromForm = function () {
		const groupMap = Object.create(null);

		form.querySelectorAll('input, textarea, select').forEach(function (el) {
			if (!el.name || el.name.indexOf('contact[') !== 0) return;
			if (el.type === 'submit') return;

			const logicalName = getLogicalFieldName(el.name);
			let value;

			if (el.type === 'checkbox') {
				if (!el.checked) return;
				value = el.value;
			} else if (el.type === 'radio') {
				if (!el.checked) return;
				value = el.value;
			} else {
				value = el.value;
			}

			if (!groupMap[logicalName]) {
				groupMap[logicalName] = {
					name: logicalName,
					label: getFieldLabel(el),
					values: [],
				};
			}

			groupMap[logicalName].values.push(value);
		});

		return Object.keys(groupMap).map(function (key) {
			const group = groupMap[key];
			return {
				name: group.name,
				label: group.label,
				value: group.values.length === 1 ? group.values[0] : group.values,
			};
		});
	};

	const buildPayload = function () {
		return {
			event: 'contact_form_submitted',
			submitted_at: new Date().toISOString(),
			form_type: configEl.dataset.formType || null,
			page: {
				handle: configEl.dataset.pageHandle || null,
				title: configEl.dataset.pageTitle || null,
				url: window.location.href,
			},
			topic: configEl.dataset.topic || null,
			fields: buildFieldsFromForm(),
		};
	};

	const postWebhook = function (payload) {
		const headers = { 'Content-Type': 'application/json' };
		if (configEl.dataset.makeApiKey) {
			headers['x-make-apikey'] = configEl.dataset.makeApiKey;
		}

		return fetch(configEl.dataset.webhookUrl, {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(payload),
		});
	};

	const setSubmittingState = function (isBusy) {
		form.querySelectorAll('[type="submit"]').forEach(function (btn) {
			btn.disabled = isBusy;
		});
	};

	form.addEventListener('submit', function (evt) {
		if (isSubmittingAfterWebhook) return;

		if (!form.checkValidity()) {
			return;
		}

		evt.preventDefault();
		setSubmittingState(true);

		postWebhook(buildPayload())
			.catch(function () {})
			.finally(function () {
				isSubmittingAfterWebhook = true;
				form.submit();
			});
	});
})();
